/* eslint-disable no-nested-ternary */
import { Col, Image, message, Select, Spin } from "antd";
import {
  ColorAntdButton,
  StyledButton,
  StyledInput
} from "common/components/StyledElements";
import APIConstants from "common/constants/APIConstants";
import COLORS from "common/constants/Colors";
import { useAuthContext } from "common/contexts/AuthContext";
import { api } from "common/utils/APIMethods";
import { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQueries } from "react-query";
import styled from "styled-components";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FormItemInner = styled.div`
  display: grid;
  grid-template-columns: 180px 0.6fr;
  margin-bottom: 30px;
`;

const BoldText = styled.div`
  color: rgba(0, 87, 84, 0.8);
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
`;

const StyledController = styled.div`
  position: relative;
  width: 70%;
`;

const ModalInput = styled(StyledInput)`
  width: 100%;
  color: #2e2e2e;
`;

const InputFileLabel = styled.label`
  border: 1px solid ${COLORS.primary_green};
  background-color: ${COLORS.primary_green};
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  color: white;
  font-weight: bold;
`;
const FormCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const InputElement = styled.input`
  height: 50px;
  border: 1.5px solid ${COLORS.primary_green};
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 10px;
  outline: none;
`;

const UploadImage = styled(Image)`
  height: 68px;
  width: 68px;
  margin-left: 40px;
  border: 1.5px solid ${COLORS.primary_green};
  border-radius: 6px;
  margin-right: 30px;
`;

const NewNotification = (props) => {
  const [stateIds, setStateIds] = useState([]);
  const { authConfig } = useAuthContext();
  const imageRef = useRef(null);

  const ROLE_TYPE = [
    {
      title: "distributor",
      value: "ROLE_DISTRIBUTOR",
      id: 1
    },
    {
      title: "retailer",
      value: "ROLE_RETAILER",
      id: 2
    },
    {
      title: "representative",
      value: "ROLE_REPRESENTATIVE",
      id: 3
    }
  ];

  const { stateList, setIsNewNotificationModalOpen } = props;
  const { allDistricts, sendNotification } = APIConstants;
  
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors }
  } = useForm({});

  const { mutate: mutateNotification, isLoading: isUpdating } = useMutation(
    (notificationData) =>
      api(
        {
          url: sendNotification,
          method: "PUT",
          body: notificationData,
          isFormData: true
        },
        authConfig
      ),
    {
      onSuccess: (response) => {
        message.success(response.message ?? "Notification Sent Successfully");
        setIsNewNotificationModalOpen(false);
      },
      onError: (error) => {
        message.error(error.message ?? "Notification Sending Failed");
      }
    }
  );

  const { Option, OptGroup } = Select;

  const districtData = useQueries(
    stateIds?.map((stateId) => ({
      queryKey: ["allDistrictList", stateId],
      queryFn: () =>
        api(
          {
            url: `${allDistricts}/${stateId}`
          },
          authConfig
        ),
      staleTime: Infinity,
      enabled: stateId !== undefined
    }))
  );
  const isDistrictsLoading = districtData.some(
    (query) => query.status === "loading"
  );
  const stateDistrictMap = new Map();
  districtData.forEach((item) => {
    stateDistrictMap.set(item?.data?.[0]?.state, item?.data);
  });

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("roles", JSON.stringify(data.role));
    formData.append("stateIds", JSON.stringify(data.state || []));
    formData.append("districtIds", JSON.stringify(data.district || []));

    formData.append("image", imageRef.current || null);

    mutateNotification(formData);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormContainer>
        <FormCol span={12}>
          <FormItemInner>
            <BoldText>Title</BoldText>
            <Controller
              name="title"
              control={control}
              rules={{ required: "Enter Title" }}
              render={({ field }) => (
                <StyledController>
                  <ModalInput
                    style={{ width: 400 }}
                    {...field}
                    placeholder="Enter Notification Title"
                    autoFocus
                  />
                  {errors?.title && (
                    <p style={{ color: "red" }}>{errors.title.message}</p>
                  )}
                </StyledController>
              )}
            />
          </FormItemInner>
        </FormCol>

        <FormCol span={12}>
          <FormItemInner>
            <BoldText>Description</BoldText>
            <Controller
              name="description"
              control={control}
              rules={{ required: "Enter Notification description" }}
              render={({ field }) => (
                <StyledController>
                  <ModalInput
                    style={{ width: 400 }}
                    {...field}
                    placeholder="Enter Notification description"
                    autoFocus
                  />
                  {errors?.description && (
                    <p style={{ color: "red" }}>{errors.description.message}</p>
                  )}
                </StyledController>
              )}
            />
          </FormItemInner>
        </FormCol>

        <FormCol span={12}>
          <FormItemInner>
            <BoldText>Send To</BoldText>
            <Controller
              name="role"
              control={control}
              rules={{ required: "select role" }}
              render={({ field }) => (
                <StyledController>
                  <Select
                    mode="multiple"
                    placeholder="Select Role"
                    size="large"
                    style={{ width: 400 }}
                    onChange={(value) => field.onChange(value)}
                    value={field.value}
                  >
                    {ROLE_TYPE.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.title}
                      </Option>
                    ))}
                  </Select>
                  {errors?.role && (
                    <p style={{ color: "red" }}>{errors.role.message}</p>
                  )}
                </StyledController>
              )}
            />
          </FormItemInner>
        </FormCol>

        <FormItemInner>
          <BoldText>Select State</BoldText>
          <Controller
            name="state"
            control={control}
            render={({ field }) => (
              <StyledController>
                <Select
                  placeholder="Select State"
                  mode="multiple"
                  size="large"
                  listHeight={150}
                  style={{ width: 740 }}
                  optionFilterProp="key"
                  onChange={(value) => {
                    if (!value) {
                      field.onChange([]);
                      setValue("district", []);
                    } else {
                      field.onChange(value);
                      setStateIds(value);
                      const tempMap = new Map(stateDistrictMap);
                      for (const key of tempMap.keys()) {
                        if (!value.includes(key.id)) {
                          tempMap.delete(key);
                        }
                      }
                      const filteredDistricts = Array.from(tempMap.values())
                        .flat()
                        .map((district) =>
                          watch("district").includes(district.id)
                            ? district.id
                            : null
                        )
                        .filter((id) => id !== null);

                      setValue("district", filteredDistricts);
                    }
                  }}
                  value={field.value}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  maxTagCount="responsive"
                  allowClear
                  placement="bottomLeft"
                >
                  {stateList?.map((item) => (
                    <Option key={item.name} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </StyledController>
            )}
          />
        </FormItemInner>
        <FormItemInner>
          <BoldText>Select District</BoldText>
          <Controller
            name="district"
            control={control}
            render={({ field }) => (
              <StyledController>
                <Select
                  loading={isDistrictsLoading}
                  placeholder="Select District"
                  mode="multiple"
                  size="large"
                  style={{ width: 740 }}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  listHeight={150}
                  value={field.value}
                  optionFilterProp="key"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  maxTagCount="responsive"
                  allowClear
                  popupMatchSelectWidth={false}
                  placement="bottomLeft"
                >
                  {Array.from(stateDistrictMap.entries())?.map(
                    ([stateName, districts]) => (
                      <OptGroup key={stateName?.id} label={stateName?.name}>
                        {districts?.map((item) => (
                          <Option key={item.name} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </OptGroup>
                    )
                  )}
                </Select>
              </StyledController>
            )}
          />
        </FormItemInner>
        <FormItemInner>
          <BoldText>Upload Image</BoldText>
          <Controller
            name="image"
            control={control}
            render={({ field }) => (
              <StyledController>
                <InputFileLabel htmlFor="imageUpload">
                  Upload File
                </InputFileLabel>
                <InputElement
                  id="imageUpload"
                  type="file"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={(e) => {
                    imageRef.current = e.target?.files[0];

                    setValue("image", URL.createObjectURL(e.target?.files[0]));
                  }}
                />

                {field.value && (
                  <>
                    <UploadImage src={field.value} />
                    <ColorAntdButton
                      color={COLORS.action_decline}
                      onClick={() => {
                        setValue("image", null);
                      }}
                    >
                      Remove File
                    </ColorAntdButton>
                  </>
                )}
              </StyledController>
            )}
          />
        </FormItemInner>
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 16 }}
        >
          <StyledButton type="primary" htmlType="submit">
            Submit {isUpdating && <Spin />}
          </StyledButton>
        </div>
      </FormContainer>
    </form>
  );
};

export default NewNotification;
